export default "__VITE_ASSET__40y5TI$m__"